<app-header></app-header>
<ng-http-loader backgroundColor="#F7721E" spinner="sk-wave"></ng-http-loader>

<style type="text/css">
  .body {
    height: 100%;
    position: relative;
    position: relative;
    padding-bottom: 6rem;
    min-height: 687px;
  }

  .wrapper {
    min-height: 100%;
    position: relative;
    overflow: hidden;
    padding-top: 85px;
  }
</style>
<div class="body">
  <div class="wrapper">
    <div class="col-md-12 top-header">
      <h3>Reset Password</h3>
    </div>
    <div class="content-wrapper" style="min-height: 487px;">
      <div class="container-fluid">
        <div id="login-interface">
          <div class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
            <div class="panel-body boxshadow" style="padding-bottom: 50px;">
              <div class="box box-default">

                <div class="box-body">

                  <div id="error-messages" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" [hidden]="!errorMessage">
                    <div class="alert alert-danger alert-dismissible">
                      <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                      <p class="erMessage">{{ errorMessage }}</p>
                    </div>
                  </div>

                  <!-- form start -->
                  <form [formGroup]='resetPasswordForm' (ngSubmit)="f.form.valid && submitPasswords()" #f="ngForm">
                    <!-- action="../resetpassword"  -->

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group" id="div_reg_password">
                        <label>New Password
                          <span class="text-danger">*</span>
                        </label>
                        <div class="row m-0 p-0" style="display: flex;align-items: center;justify-content: center;">
                          <div class="col-md-11 m-0 p-0">
                            <input type="password" formControlName="fppassword" autocomplete="off" class="form-control" [ngClass]="{ 'error-border': f.submitted && resetPasswordForm.get('fppassword').errors}"
                            placeholder="Enter New Password"/>
                            <p *ngIf="f.submitted && resetPasswordForm.get('fppassword').errors?.required" id="ngp_reg_email" class="text-danger">This value is required.</p>
                            <div *ngIf="f.submitted && resetPasswordForm.get('fppassword').errors?.pattern" class="text-danger">
                              <p class="m-0" style="margin: 0px;">The password must be a minimum of 8 characters and should contain at least one upper- and lower-case letter, a number, and a special character</p>
                            </div>
                          </div>
                          <div class="col-md-1 m-0 p-0">
                            <i *ngIf="!show" (click)="password()" style="font-size: 20px;" class="bx bxs-show bx-lg"></i>
                            <i *ngIf="show" (click)="password()" style="font-size: 20px;" class="bx bxs-hide bx-lg"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group" id="div_confirmpassword">
                        <label>Confirm Password
                          <span class="text-danger">*</span>
                        </label>
                        <div class="row m-0 p-0" style="display: flex;align-items: center;justify-content: center;">
                          <div class="col-md-11 m-0 p-0">
                            <input type="password" formControlName="fpconfirmpassword" class="form-control" placeholder="Enter Confirm Password" [ngClass]="{ 'error-border': f.submitted && resetPasswordForm.get('fpconfirmpassword').errors}"
                            required>
                            <p *ngIf="f.submitted && resetPasswordForm.get('fpconfirmpassword').errors?.required" id="ngp_reg_email" class="text-danger">This value is required.</p>
                            <p *ngIf="f.submitted && resetPasswordForm.get('fpconfirmpassword').errors?.mustMatch" class="text-danger">This value should be the same.</p>                          
                            <p id="ngp_confirmpassword" class="text-danger hidden"></p>
                          </div>
                          <div class="col-md-1 m-0 p-0">
                            <i *ngIf="!confirmShow" (click)="confirmPassword()" style="font-size: 20px;" class="bx bxs-show bx-lg"></i>
                            <i *ngIf="confirmShow" (click)="confirmPassword()" style="font-size: 20px;" class="bx bxs-hide bx-lg"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px;">
                      <div class="row d-flex">
                        <div class="col-md-1">
                          <input type="checkbox" checked id="remember" name="remember" (change)="onAgreeChange($event)">
                        </div>
                        <div class="col-md-11 m-0 p-0" style="margin: 0px;padding: 0px;">
                          <label for="remember" class="label-checkbox">Sign out of all sessions and all devices.</label>  
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <button id="btnSubmit" type="submit" class="btn btn-primary next pull-right">Submit</button>
                    </div>

                  </form>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>